"use strict";
/* eslint-disable max-lines */
/* eslint-disable functional/no-class */
/* eslint-disable functional/prefer-readonly-type */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commercetoolsSetPartnerAssociation = exports.commercetoolsCreatePartnerAssociationCart = exports.commercetoolsVerifyEligibility = exports.commercetoolsVerifySS2Eligibility = exports.commercetoolsSetCustomerGroup = exports.commercetoolsCreateUpgradeCart = exports.commercetoolsReplicateCart = exports.commercetoolsGetShippingMethodsV2 = exports.commercetoolsGetShippingMethods = exports.commercetoolsSaveMySystem = exports.commercetoolsAddBmsToCart = exports.buildCustomFieldUpdateAction = exports.buildOrderExternalReferencesUpdateAction = exports.buildBillingAddressUpdateAction = exports.buildShippingAddressUpdateAction = exports.commercetoolsDeleteCart = exports.commercetoolsUpdateCart = exports.commercetoolsAddToCart = exports.commercetoolsGetCartByQuoteId = exports.commercetoolsGetCart = exports.CTCartToRecord = exports.toTotalCartDiscount = exports.toShippingRateInput = exports.isPackageParent = exports.getCartDetails = exports.isAnyBms = exports.groupByProductTypeAndParentId = exports.getPriceValue = exports.ImmutableCart = void 0;
const hasPath_1 = __importDefault(require("@simplisafe/ewok/ramda-adjunct/hasPath"));
const transformObject_1 = __importDefault(require("@simplisafe/ewok/transformObject"));
const monda_1 = require("@simplisafe/monda");
const immutable_1 = require("immutable");
const monet_1 = require("monet");
const ramda_1 = require("ramda");
const always_1 = __importDefault(require("ramda/src/always"));
const any_1 = __importDefault(require("ramda/src/any"));
const applySpec_1 = __importDefault(require("ramda/src/applySpec"));
const assoc_1 = __importDefault(require("ramda/src/assoc"));
const cond_1 = __importDefault(require("ramda/src/cond"));
const flatten_1 = __importDefault(require("ramda/src/flatten"));
const groupBy_1 = __importDefault(require("ramda/src/groupBy"));
const head_1 = __importDefault(require("ramda/src/head"));
const ifElse_1 = __importDefault(require("ramda/src/ifElse"));
const length_1 = __importDefault(require("ramda/src/length"));
const map_1 = __importDefault(require("ramda/src/map"));
const path_1 = __importDefault(require("ramda/src/path"));
const pathEq_1 = __importDefault(require("ramda/src/pathEq"));
const prop_1 = __importDefault(require("ramda/src/prop"));
const propEq_1 = __importDefault(require("ramda/src/propEq"));
const reduce_1 = __importDefault(require("ramda/src/reduce"));
const T_1 = __importDefault(require("ramda/src/T"));
const values_1 = __importDefault(require("ramda/src/values"));
const without_1 = __importDefault(require("ramda/src/without"));
const ts_functional_pipe_1 = require("ts-functional-pipe");
const constants_1 = require("../constants");
const commercetools_1 = require("../secrets/commercetools");
const commercetoolsClient_1 = require("./commercetoolsClient");
const price_1 = require("./price");
class ImmutableCart extends (0, immutable_1.Record)({
    billingAddress: (0, monet_1.None)(),
    cartState: 'Active',
    custom: (0, monet_1.None)(),
    customerGroup: (0, monet_1.None)(),
    discountCodes: (0, monet_1.None)(),
    id: '',
    isThereAnySecurity: false,
    lineItems: [],
    shippingAddress: (0, monet_1.None)(),
    shippingInfo: (0, monet_1.None)(),
    shippingRateInput: 0,
    subTotal: 0,
    taxedPrice: (0, monet_1.None)(),
    totalCartDiscount: 0,
    totalCartDiscountWithoutGiftItems: 0,
    totalPrice: 0,
    version: 0,
}) {
    constructor(params) {
        super(params);
    }
}
exports.ImmutableCart = ImmutableCart;
const toChild = (0, transformObject_1.default)({
    name: (0, prop_1.default)('name'),
    quantity: (0, prop_1.default)('quantity'),
    sku: (lineItem) => (0, monda_1.safePath)(['custom', 'fields', 'product_key'], lineItem).getOrElse(''),
});
const pathProductType = [
    'productType',
    'obj',
    'key',
];
const getPriceValue = (l) => (0, monda_1.safePath)(['price', 'discounted', 'value'], l)
    .orElse((0, monda_1.safePath)(['price', 'value'], l))
    .map((x) => ({
    ...x,
    centAmount: (0, prop_1.default)('centAmount', x) * (0, prop_1.default)('quantity', l),
}))
    .map(price_1.formatCTPriceToNumber)
    .getOrElse(0);
exports.getPriceValue = getPriceValue;
const sortKeyedLineItem = (keyedLineItems) => [...Object.keys(keyedLineItems)].sort().reduce((acc, key) => ({
    ...acc,
    [key]: [...keyedLineItems[key]],
}), {});
const flattenKeyedLineItemss = (sortKey) => (keyedLineItems) => {
    const mapLineItems = sortKey
        ? sortKeyedLineItem(keyedLineItems)
        : keyedLineItems;
    return (0, flatten_1.default)((0, values_1.default)(mapLineItems));
};
const groupByProductType = (0, cond_1.default)([
    [
        (item) => (0, propEq_1.default)('productType', 'package_parent', item) ||
            (0, propEq_1.default)('productType', 'service', item),
        (0, always_1.default)('1stOrder'),
    ],
    [(0, propEq_1.default)('isGift', true), (0, always_1.default)('3rdOrder')],
    [T_1.default, (0, always_1.default)('2ndOrder')],
]);
//Grouping lineItems by parent id if lineItems has any package
const groupByProductTypeAndParentId = (lineItems) => (0, monda_1.safeFind)((i) => !!(0, path_1.default)(pathPackageParentId, i), lineItems)
    .orElse((0, monda_1.safeFind)((0, propEq_1.default)('isGift', true), lineItems))
    .map(() => (0, groupBy_1.default)(groupByProductType, lineItems))
    .map(flattenKeyedLineItemss(true))
    .map((0, groupBy_1.default)((item) => (0, monda_1.safePath)(pathPackageParentId, item).orJust((0, prop_1.default)('sku', item))))
    .map(flattenKeyedLineItemss(false))
    .getOrElse(lineItems);
exports.groupByProductTypeAndParentId = groupByProductTypeAndParentId;
// TODO update this to use transformObject instead of applySpec and fix types
const simplifyCTLineItem = (0, applySpec_1.default)({
    child: (0, prop_1.default)('child'),
    custom: (0, prop_1.default)('custom'),
    discountedPrice: (0, ts_functional_pipe_1.pipe)((0, path_1.default)(['discountedPrice', 'value']), price_1.maybePrice),
    discountedPricePerQuantity: (0, ts_functional_pipe_1.pipe)((0, path_1.default)(['discountedPricePerQuantity', 'discountedPrice']), price_1.maybePrice),
    isGift: (0, propEq_1.default)('lineItemMode', 'GiftLineItem'),
    lineItemId: (0, prop_1.default)('id'),
    name: (0, prop_1.default)('name'),
    price: exports.getPriceValue,
    productType: (0, path_1.default)(pathProductType),
    quantity: (0, prop_1.default)('quantity'),
    sku: (0, path_1.default)(['variant', 'sku']),
    taxedPrice: (0, ts_functional_pipe_1.pipe)((0, prop_1.default)('taxedPrice'), price_1.maybePrice),
    totalPrice: (0, ts_functional_pipe_1.pipe)((0, prop_1.default)('totalPrice'), price_1.priceOrZero),
});
const pathPackageParentId = [
    'custom',
    'fields',
    'package_parent_id',
];
const pathProductKey = [
    'custom',
    'fields',
    'product_key',
];
const pathIsBms = [
    'custom',
    'fields',
    'product_is_bms',
];
const proSetupSkus = ['SSPSH-ON', 'SSPSH-UK'];
const isAnyParentPackage = (lineItems) => (0, any_1.default)((0, hasPath_1.default)(pathPackageParentId))(lineItems);
const isAnyBms = (lineItems) => (0, any_1.default)((0, pathEq_1.default)(pathIsBms, true))(lineItems);
exports.isAnyBms = isAnyBms;
/**
 * Given a line item, determine its grouping key.
 *
 * @param lineItem The line item to group.
 * @return string The parent package ID when the line item is a system or system component; the line item ID otherwise.
 * @see groupLineItemsByParent
 */
const lineItemGroupKey = (lineItem) => {
    const lineItemId = lineItem.lineItemId;
    const parentId = (0, path_1.default)(pathPackageParentId, lineItem);
    const productSku = (0, path_1.default)(pathProductKey, lineItem);
    const isProSetup = proSetupSkus.some((sku) => sku === productSku);
    const isServicePlan = lineItem.productType === constants_1.ProductTypes.Service;
    return !!parentId && !isProSetup && !isServicePlan ? parentId : lineItemId;
};
/**
 * Creates a list of line item "groups" based on parent.
 *
 * Each custom security system and its component line items are all grouped together as a single line item in
 * the cart view. Any other line items, including prebuilt systems, monitoring plans, installation plans, and
 * standalone components will not be grouped together. Instead, each of these line items will display as its
 * own line in the cart view.
 *
 * @param lineItems The line items to divide into groups.
 * @return A list of line items grouped by parent. Each element is a single grouping.
 */
const groupLineItemsByParent = (lineItems) => {
    const groupings = (0, groupBy_1.default)(lineItemGroupKey, lineItems);
    return Object.values(groupings)
        .filter((lineItems) => lineItems.length > 0);
};
/**
 * Appends OPT-VARIATION-IDS Header to cart api requests
 * @param request
 * @param variationId
 * @returns
 */
function appendOptVariationIdHeader(request, variationId) {
    return variationId.cata(() => request, (variationId) => {
        return (0, ramda_1.mergeDeepRight)(request, { headers: { 'OPT-VARIATION-IDS': variationId }, });
    });
}
/**
 * Will return back line items if there is no any parent package
 * will finalize the line items value including bms, regular package, and singular item
 * @param parentPackageSku
 * @param lineItems
 */
// TODO: This function is overly complicated and doesn't have adequate unit test coverage
// (just because jest reports 100% test coverage doesn't mean that everything is meaningfully tested)
const getCartDetails = (hiddenProductSkus) => (cartLineItems) => {
    const overrideChild = (packageLineItems) => {
        const parent = (0, monda_1.safeFind)((0, pathEq_1.default)(pathIsBms, true))(packageLineItems); // TODO: this as LineItem is holding all of this together and all of this needs to have the types corrected to work without it
        const mChild = parent.chain((_parent) => monet_1.Maybe.fromUndefined((0, without_1.default)([_parent])(packageLineItems)));
        // convert what are now line items to children, but also include children from the identified parent
        // todo this is an example of how overly complicated this file is
        const childs = mChild
            .map((0, map_1.default)(toChild))
            .getOrElse([])
            .concat(parent.chain((_parent) => (0, monda_1.safeProp)('child', _parent)).getOrElse([]));
        const getPrice = (key) => mChild
            .map((0, reduce_1.default)((acc, lineItem) => acc + (0, prop_1.default)(key, lineItem), 0))
            .getOrElse(0);
        const totalChildTotalPrice = getPrice('totalPrice');
        const totalChildPrice = getPrice('price');
        return {
            // TODO the parent type should never be an empty object
            // This should return a Maybe and remove all of the getOrElse functions
            // @ts-ignore
            ...parent.getOrElse({}),
            child: [...childs],
            price: totalChildPrice,
            totalPrice: totalChildTotalPrice,
        };
    };
    const filterHiddenChildren = (lineItem) => ({
        ...lineItem,
        child: (0, monda_1.safeProp)('child', lineItem)
            .map((children) => children.filter((product) => (0, monda_1.safeProp)('sku', product)
            .map((sku) => !hiddenProductSkus.includes(sku))
            .getOrElse(true)))
            .getOrElse([]),
    });
    const filterHiddenProducts = (lineItem) => !hiddenProductSkus.includes(lineItem.sku);
    // Accepts a list of at least one line item so that we can potentially grab the first item out of it without
    // ending up with an undefined value.
    const mapToBmsParent = (lineItems) => {
        // TODO this logic should be hardened/fixed; the way that overrideChild works, this assumes that if we have multiple
        // lineItems with the same package parent, one of them is going to be a BMS package parent
        const mappedLineItem = (0, length_1.default)(lineItems) > 1 ? overrideChild(lineItems) : (0, head_1.default)(lineItems);
        return filterHiddenChildren(mappedLineItem);
    };
    const groupAndMapToBmsParent = (lineItems) => {
        const mappedLineItems = groupLineItemsByParent(lineItems)
            .map(mapToBmsParent);
        return (0, exports.groupByProductTypeAndParentId)(mappedLineItems);
    };
    return (0, ifElse_1.default)(exports.isAnyBms, groupAndMapToBmsParent, (0, ts_functional_pipe_1.pipe)((_lineItems) => _lineItems.filter(filterHiddenProducts).map(filterHiddenChildren), exports.groupByProductTypeAndParentId))(cartLineItems);
};
exports.getCartDetails = getCartDetails;
/**
 * CT sometimes doesn't expand the lineItems[*].productType reference on its return from cart creation.
 * Looking at productMap hedges our bets on detecting a package.
 * This could be reverted to just looking at productType.obj.key once that's figured out.
 */
const isPackageParent = (lineItem) => {
    const isPackageParent = (0, path_1.default)(pathProductType, lineItem) === constants_1.ProductTypes.PackageParent;
    const hasProductMapAttribute = lineItem.variant.attributes?.some((attribute) => attribute.name === 'productMap');
    return isPackageParent || hasProductMapAttribute;
};
exports.isPackageParent = isPackageParent;
// TODO: split up cart functions into multiple files
/**
 * return simplifyCTlineItem if there is no packageParentId
 * otherwise, filter customLineItems that has same packageParentId, transform to children,
 * and then assoc to lineItem which has same package parent id
 */
const moveChildFromCustomToParent = (customLineItems) => (lineItem) => (0, monda_1.safePath)(pathPackageParentId, lineItem).cata(() => simplifyCTLineItem(lineItem), (parentId) => {
    const simplifiedLineItem = simplifyCTLineItem(lineItem);
    const simplifiedLineItemWithChild = monet_1.Maybe.fromNull(customLineItems)
        .map((_customLineItems) => _customLineItems
        .filter((0, pathEq_1.default)(pathPackageParentId, parentId))
        .map(toChild))
        .map((_children) => (0, assoc_1.default)('child', _children, lineItem))
        .map(simplifyCTLineItem)
        .orJust(simplifiedLineItem);
    return (0, exports.isPackageParent)(lineItem)
        ? simplifiedLineItemWithChild
        : simplifiedLineItem;
});
/**
 * check is there any parent package on lineItems, if exists map child from custom line items to each parent
 * otherwise simplifyCTLineItem
 */
const mappingLineItems = (lineItems, customLineItems) => (0, ifElse_1.default)(isAnyParentPackage, (0, map_1.default)(moveChildFromCustomToParent(customLineItems)), (0, map_1.default)(simplifyCTLineItem))(lineItems);
const toTaxedPrice = (c) => (0, monda_1.safeProp)('taxedPrice', c).map((p) => (0, price_1.formatCTPriceToNumber)(p.totalGross) - (0, price_1.formatCTPriceToNumber)(p.totalNet));
const toSubTotal = (c) => (0, monda_1.safeProp)('lineItems', c)
    .map((0, reduce_1.default)((acc, item) => acc + (0, exports.getPriceValue)(item), 0))
    .getOrElse(0);
const toTotalPrice = (c) => (0, monda_1.safeProp)('taxedPrice', c)
    .chain((0, monda_1.safeProp)('totalGross'))
    .orElse((0, monda_1.safeProp)('totalPrice', c))
    .map(price_1.formatCTPriceToNumber)
    .getOrElse(0);
const toShippingRateInput = (c) => (0, monda_1.safeProp)('shippingRateInput', c)
    .chain((s) => ('score' in s ? (0, monda_1.safeProp)('score', s) : (0, monet_1.None)()))
    .getOrElse(0);
exports.toShippingRateInput = toShippingRateInput;
const filterGiftsAndCartDiscounts = (lineItems) => lineItems.filter((lineItem) => (0, monda_1.safeProp)('lineItemMode', lineItem).getOrElse('Standard') !==
    'GiftLineItem');
const toTotalCartDiscount = (c, withGiftItems = true) => (0, monda_1.safeProp)('lineItems', c)
    .map(lineItems => withGiftItems ? lineItems : filterGiftsAndCartDiscounts(lineItems))
    .map((0, reduce_1.default)((acc, item) => acc + (0, monda_1.safeProp)('discountedPricePerQuantity', item)
    .map((0, reduce_1.default)((accu, amount) => accu + monet_1.Maybe.some(amount)
    .chain(discounted => (0, monda_1.safeProp)('discountedPrice', discounted)
    .chain((0, monda_1.safeProp)('includedDiscounts'))
    .chain(monda_1.safeHead)
    .chain((0, monda_1.safeProp)('discountedAmount'))
    .map(price => ({
    ...price,
    centAmount: (0, prop_1.default)('centAmount', price) * (0, prop_1.default)('quantity', discounted)
}))
    .map(price_1.formatCTPriceToNumber))
    .getOrElse(0), 0))
    .map(price_1.formatPriceWithFractionDigits)
    .getOrElse(0), 0))
    .some();
exports.toTotalCartDiscount = toTotalCartDiscount;
const simplifyCTCart = (0, transformObject_1.default)({
    billingAddress: (0, monda_1.safeProp)('billingAddress'),
    cartState: (0, prop_1.default)('cartState'),
    custom: (0, monda_1.safeProp)('custom'),
    customerGroup: (0, monda_1.safeProp)('customerGroup'),
    discountCodes: (0, monda_1.safeProp)('discountCodes'),
    id: (0, prop_1.default)('id'),
    isThereAnySecurity: (0, ts_functional_pipe_1.pipe)((0, prop_1.default)('lineItems'), isAnyParentPackage),
    lineItems: (cart) => mappingLineItems((0, prop_1.default)('lineItems', cart), (0, prop_1.default)('customLineItems', cart)),
    shippingAddress: (0, monda_1.safeProp)('shippingAddress'),
    shippingInfo: (0, monda_1.safeProp)('shippingInfo'),
    shippingRateInput: exports.toShippingRateInput,
    subTotal: toSubTotal,
    taxedPrice: toTaxedPrice,
    totalCartDiscount: (cart) => (0, exports.toTotalCartDiscount)(cart, true),
    totalCartDiscountWithoutGiftItems: (cart) => (0, exports.toTotalCartDiscount)(cart, false),
    totalPrice: toTotalPrice,
    version: (0, prop_1.default)('version'),
});
const CTCartToRecord = (cart) => new ImmutableCart(simplifyCTCart(cart));
exports.CTCartToRecord = CTCartToRecord;
const commercetoolsGetCart = (id, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    endpoint: `${commercetools_1.cartUrl}/${id}?${commercetools_1.expandProductType}&${commercetools_1.expandDiscountCode}&${commercetools_1.expandCustomerGroup}`,
    method: 'GET',
}, variationId));
exports.commercetoolsGetCart = commercetoolsGetCart;
const commercetoolsGetCartByQuoteId = (id, emailHash, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    endpoint: `${commercetools_1.cartUrl}/quote/${emailHash}/${id}`,
    method: 'GET',
}, variationId));
exports.commercetoolsGetCartByQuoteId = commercetoolsGetCartByQuoteId;
const endpointId = (id) => (id ? `/${id}` : '');
/**
 * Adds items to the cart. If a cart ID is not passed, it will create a cart.
 */
const commercetoolsAddToCart = (id, variationId = (0, monet_1.None)()) => (body) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: id ? 'addToCart' : 'createCart',
                ...body,
            },
        ],
    }),
    endpoint: `${commercetools_1.cartUrl}${endpointId(id)}?${commercetools_1.expandProductType}&${commercetools_1.expandDiscountCode}&${commercetools_1.expandCustomerGroup}`,
    //will be uncommented once patch is ready
    // method: id ? 'PATCH' : 'POST'
    method: 'POST',
}, variationId));
exports.commercetoolsAddToCart = commercetoolsAddToCart;
const commercetoolsUpdateCart = (id, variationId = (0, monet_1.None)()) => (actions) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({ actions }),
    endpoint: `${commercetools_1.cartUrl}/${id}?${commercetools_1.expandProductType}&${commercetools_1.expandDiscountCode}&${commercetools_1.expandCustomerGroup}`,
    method: 'POST',
}, variationId));
exports.commercetoolsUpdateCart = commercetoolsUpdateCart;
const commercetoolsDeleteCart = (id) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.cartUrl}/${id}`,
    method: 'DELETE',
});
exports.commercetoolsDeleteCart = commercetoolsDeleteCart;
const buildShippingAddressUpdateAction = (address) => ({
    action: 'setShippingAddress',
    address,
});
exports.buildShippingAddressUpdateAction = buildShippingAddressUpdateAction;
const buildBillingAddressUpdateAction = (address) => ({
    action: 'setBillingAddress',
    address,
});
exports.buildBillingAddressUpdateAction = buildBillingAddressUpdateAction;
const buildOrderExternalReferencesUpdateAction = ({ leadSource, leadOther, }) => ({
    action: 'setCustomType',
    fields: {
        leadOther,
        leadSource,
    },
    type: { key: 'order_external_references' },
});
exports.buildOrderExternalReferencesUpdateAction = buildOrderExternalReferencesUpdateAction;
const buildCustomFieldUpdateAction = ({ name, value, }) => ({
    action: 'setCustomField',
    name,
    value,
});
exports.buildCustomFieldUpdateAction = buildCustomFieldUpdateAction;
const commercetoolsAddBmsToCart = (id, variationId = (0, monet_1.None)()) => (body) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: id ? 'addBmsToCart' : 'createBmsCart',
                ...body,
            },
        ],
    }),
    endpoint: `${commercetools_1.cartUrl}${endpointId(id)}?${commercetools_1.expandProductType}&${commercetools_1.expandDiscountCode}&${commercetools_1.expandCustomerGroup}`,
    method: 'POST',
}, variationId));
exports.commercetoolsAddBmsToCart = commercetoolsAddBmsToCart;
const commercetoolsSaveMySystem = (_id, variationId = (0, monet_1.None)()) => (body) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: 'saveMySystem',
                saveOrderAsQuote: true,
                ...body,
            },
        ],
    }),
    endpoint: commercetools_1.cartUrl,
    method: 'POST',
}, variationId));
exports.commercetoolsSaveMySystem = commercetoolsSaveMySystem;
const commercetoolsGetShippingMethods = (id) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.productUrl}/shipping-methods/matching-cart?cartId=${id}&expand=zoneRates[*].zone.id`,
    method: 'GET',
});
exports.commercetoolsGetShippingMethods = commercetoolsGetShippingMethods;
const commercetoolsGetShippingMethodsV2 = (id) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.shippingMethodsUrl}/matching-cart?cartId=${id}&expand=zoneRates[*].zone.id`,
    method: 'GET',
});
exports.commercetoolsGetShippingMethodsV2 = commercetoolsGetShippingMethodsV2;
const commercetoolsReplicateCart = (cartId, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    endpoint: `${commercetools_1.cartUrl}/replicate/${cartId}?${commercetools_1.expandProductType}&${commercetools_1.expandDiscountCode}&${commercetools_1.expandCustomerGroup}`,
    method: 'POST',
}, variationId));
exports.commercetoolsReplicateCart = commercetoolsReplicateCart;
const commercetoolsCreateUpgradeCart = (userId, locale, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: 'createUpgradeCart',
                locale: locale,
                products: [],
                userId: userId,
            },
        ],
    }),
    endpoint: commercetools_1.cartUrl,
    method: 'POST',
}, variationId));
exports.commercetoolsCreateUpgradeCart = commercetoolsCreateUpgradeCart;
const commercetoolsSetCustomerGroup = (userId, cartId, customerGroup, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: 'setCustomerGroup',
                customerGroup: customerGroup,
                userId: userId,
            },
        ],
    }),
    endpoint: `${commercetools_1.cartUrl}/${cartId}`,
    method: 'POST',
}, variationId));
exports.commercetoolsSetCustomerGroup = commercetoolsSetCustomerGroup;
const commercetoolsVerifySS2Eligibility = (userId) => (0, commercetoolsClient_1.commercetoolsFetch)({
    endpoint: `${commercetools_1.cartUrl}/ss2/verification/${userId}`,
    method: 'GET',
});
exports.commercetoolsVerifySS2Eligibility = commercetoolsVerifySS2Eligibility;
const commercetoolsVerifyEligibility = (userId, customerGroup) => (0, commercetoolsClient_1.commercetoolsFetch)({
    body: JSON.stringify({
        customerGroup: customerGroup,
        userId: userId,
    }),
    endpoint: `${commercetools_1.customerGroupUrl}/eligible`,
    method: 'POST',
});
exports.commercetoolsVerifyEligibility = commercetoolsVerifyEligibility;
const commercetoolsCreatePartnerAssociationCart = (customerGroup, partnerName, locale, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: 'createPartnerAssociationCart',
                customerGroup: customerGroup,
                locale: locale,
                partnerName: partnerName,
                products: [],
            },
        ],
    }),
    endpoint: commercetools_1.cartUrl,
    method: 'POST',
}, variationId));
exports.commercetoolsCreatePartnerAssociationCart = commercetoolsCreatePartnerAssociationCart;
const commercetoolsSetPartnerAssociation = (customerGroup, partnerName, cartId, variationId = (0, monet_1.None)()) => (0, commercetoolsClient_1.commercetoolsFetch)(appendOptVariationIdHeader({
    body: JSON.stringify({
        actions: [
            {
                action: 'setPartnerAssociation',
                customerGroup: customerGroup,
                partnerName: partnerName,
            },
        ],
    }),
    endpoint: `${commercetools_1.cartUrl}/${cartId}`,
    method: 'POST',
}, variationId));
exports.commercetoolsSetPartnerAssociation = commercetoolsSetPartnerAssociation;
//# sourceMappingURL=cart.js.map